module.exports = "\r\n<div id=\"heatmap\"></div>"